import React, { useState } from "react";
import { BsCartPlus, BsCartDash } from "react-icons/bs";
import { useCart } from "../../context/CartContext";
import { useTheme } from "../../context/ThemeProvider";
import { toast } from "react-toastify";

const CartButton = ({ video }) => {
  const { addToCart, removeFromCart, isInCart } = useCart();
  const { darkMode } = useTheme();
  
  const [isHovered, setIsHovered] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Derive active state synchronously from context
  const inCart = isInCart(video._id);

  const handleClick = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (isProcessing) return;
    
    // Trigger pop animation immediately
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 300);
    setIsProcessing(true);

    try {
      if (inCart) {
        await removeFromCart(video._id);
        toast.success("Removed from cart");
      } else {
        const result = await addToCart(video);
        if (result.success) {
          toast.success(result.message || "Added to cart");
        } else {
          toast.error(result.message || "Could not add to cart");
        }
      }
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div
      className="relative flex items-center cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <div 
        className={`h-8 w-8 rounded-full border flex items-center justify-center transition-all duration-200
          ${isAnimating ? "scale-110" : "scale-100"}
          ${inCart 
            ? "bg-[#004A1B] border-[#004A1B] text-white" 
            : "border-white bg-transparent text-white hover:bg-white/20"
          }
        `}
      >
        {inCart ? (
          <BsCartDash className="text-[18px]" />
        ) : (
          <BsCartPlus className="text-[18px]" />
        )}
      </div>
      <span
        className={`pointer-events-none absolute left-full top-1/2 ml-2 -translate-y-1/2 whitespace-nowrap text-[11px] ${
          darkMode ? "bg-[#1B1D1C] text-white" : "bg-white text-gray-700"
        } ${
          isHovered ? "opacity-100" : "opacity-0"
        } z-20 rounded px-2 py-1 shadow transition-opacity duration-150`}
      >
        {inCart ? "Remove from Cart" : "Add to Cart"}
      </span>
    </div>
  );
};

export default CartButton;
